module.exports = __webpack_public_path__ + "assets/img/background_img.117efa22.svg";